var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"headTitle"},[_c('img',{staticStyle:{"transform":"rotate(180deg)"},attrs:{"src":_vm.Left},on:{"click":_vm.goBack}}),_c('span',{domProps:{"textContent":_vm._s(_vm.title)}})]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }